// @ts-nocheck
import {
  Button as MButton,
  ButtonGroup,
  TextField,
  Typography
} from "@material-ui/core";
import clsx from "clsx";
import _ from "lodash";
import React, { useState, useMemo } from "react";
import { t } from "ttag";
import { Button, IconButton, Select } from '@coolremote/shared';
import { Close, InfoIcon, Plus } from "../../icons";
import Tooltip from "../Tooltip/LightTooltip";
import styles from "./AutomationRule.style";


const CustomSelect = ({ className, error, disabled, options = [], value, placeholder, onChange, optionValue = "value", label = "name", name, formLabel, adaptiveWidth=false }: any) => {
  const classes = styles();

  const mappedOptions = _.isEmpty(options)
    ? [{ value: "none", label: t`No Options`, disabled: true }]
    : options.map((option: any) => ({
        value: option[optionValue],
        label: option.tooltip ? (
          <span className={classes.optionWithTooltip}>
            {option[label]}
            <Tooltip title={option.tooltip} placement="right" PopperProps={{ style: { zIndex: 10000 } }}>
              <span className={classes.optionTooltipTrigger}>
                <InfoIcon style={{ color: '#aaa2aa' }} width={14} height={14} />
              </span>
            </Tooltip>
          </span>
        ) : option[label],
        disabled: !!option.readOnly,
      }));

  const floatingLabel = formLabel || placeholder;

  const triggerClass = clsx(classes.selectTrigger, { [classes.disabled]: disabled })

  return (

    <Select
      fullWidth
      menuPortal
      floatingLabel
      className={clsx(classes.selectBaseClass, className || classes.minWidth160)}
      disabled={disabled || options.length === 0}
      value={value === undefined ? "" : (value || "")}
      onChange={(val: any) => onChange({ target: { value: val, name } })}
      error={!!error}
      options={mappedOptions}
      classes={{ trigger: triggerClass, option: classes.optionStyle }}
      label={floatingLabel}
      adaptiveWidth
    />
  );
};

const Box = ({ title, children, small, bLabel1, bLabel2, bDisabled1, bDisabled2, action1, action2, className, addBottomMargin, boxRef }: any) => {
  const classes = styles();

  return <div id="box1" className={clsx(classes.boxContainer, { [classes.small]: small, [classes.addBottomMargin]: addBottomMargin, [className]: className })}>
    <div id="box-header1" className={classes.boxHeader}>
      <Typography className={classes.boxTitle}>{title}</Typography>
      <div style={{ display: 'flex' }}>
        {action1 && <Button
          white
          width={small ? 130 : 144}
          className={clsx(classes.btn, classes.addMargin13, { [classes.disabledWhiteButton]: bDisabled1 })}
          startIcon={<Plus className={classes.plusIcon} />}
          disabled={bDisabled1}
          onClick={action1}
          onMouseDown={(event: any) => { event.preventDefault(); }}
        >
          {bLabel1}
        </Button>}
        {action2 && <Button onMouseDown={(event: any) => { event.preventDefault(); }} white width={110} className={clsx(classes.btn, { [classes.disabledWhiteButton]: bDisabled2 })} disabled={bDisabled2} onClick={action2}
          startIcon={small ? <Plus className={classes.plusIcon} /> : undefined} >
          {bLabel2}
        </Button>}
      </div>
    </div>
    <div ref={boxRef} className={clsx(classes.boxContent, { [classes.unitsAppliedBox]: small })}>{children}</div>
  </div >;
};

const CustomedTextField = ({ maxLength = "", error, label, disabled, placeholder, value, width, normalMargin, className, onChange, name, type = "string" }: any, props: any) => {
  const classes = styles();

  return <TextField
    label={label}
    disabled={disabled}
    classes={{ root: classes.label }}
    name={name}
    value={value}
    style={width ? { width } : undefined}
    onChange={onChange}
    placeholder={placeholder}
    variant="outlined"
    error={error}
    className={clsx(classes.textField, { [classes.addMargin]: !normalMargin, [className]: className, [classes.disabled]: disabled })}
    type={type}
    inputProps={{ maxLength }}
  />;
};


const UnitWrapper = ({ onRemove, siteName, systemName, unitName, disabled = false }: any) => {
  const classes = styles();

  return <div className={classes.wrapperContainer}>
    <Tooltip arrow interactive placement="top-start" title={siteName + " /" + systemName + " /" + unitName}>
      <Typography className={classes.namesContainer}><span className={classes.name}>{siteName || ""}</span> <span className={classes.middle}>/</span> <span className={classes.name}>{systemName || ""}</span><span className={classes.middle}>/</span> <span className={classes.name}>{unitName || ""}</span></Typography>
    </Tooltip>
    <IconButton disabled={disabled} className={classes.removeButton} onClick={onRemove}><Close color="#fff" /></IconButton></div>;
};

const SystemWrapper = ({ onRemove, siteName, systemName, disabled = false }: any) => {
  const classes = styles();

  return <div className={classes.wrapperContainer}>
    <Tooltip arrow interactive placement="top-start" title={siteName + " /" + systemName} >
      <Typography className={classes.namesContainer}><span className={classes.name}>{siteName || ""}</span> <span className={classes.middle}>/</span> <span className={classes.name}>{systemName}</span></Typography>
    </Tooltip>
    <IconButton disabled={disabled} className={classes.removeButton} onClick={onRemove}><Close color="#fff" /></IconButton></div>;
};

const TextInput = ({
  id,
  label,
  error,
  className,
  onChange,
  ...props
}: any) => {
  const classes = clsx(
    "input-group",
    {
      "animated shake error": !!error
    }
    // className
  );
  return (
    <div className={classes}>
      <label htmlFor={id}>
        {label}
      </label>
      <input
        id={id}
        className="text-input"
        onChange={onChange}
        {...props}
      />
      <p>]{error} </p>
    </div>
  );
};

const CustomAutoComplete = ({
  filters = {},
  className,
  error,
  disabled,
  options = [],
  value,
  placeholder,
  onChange,
  label = 'name',
  name,
  getOptionDisabledCondition,
  formLabel,
  optionValue = "value",
}: any) => {
  const classes = styles();

  const mappedOptions = useMemo(() => {
    return options.map((option: any) => ({
      value: option[optionValue],
      label: option[label] || "",
      disabled: getOptionDisabledCondition ? getOptionDisabledCondition(option) : !!option.disabled,
    }));
  }, [options, optionValue, label, getOptionDisabledCondition]);

  const currentValue = value?.[optionValue] ?? (typeof value === "string" ? value : "");
  const floatingLabel = formLabel || placeholder;
  const triggerClass = clsx(classes.autoCompleteTrigger, { [classes.disabled]: disabled })


  return (
    <Select
      fullWidth
      menuPortal
      searchable
      floatingLabel
      disabled={disabled}
      value={currentValue}
      className={clsx(classes.selectBaseClass, className || classes.width180)}
      onChange={(val: any) => {
        const found = options.find((o: any) => String(o[optionValue]) === String(val));
        onChange(null, found || null);
      }}
      error={!!error}
      options={mappedOptions}
      label={floatingLabel}
      classes={{ trigger: triggerClass, option: classes.optionStyle }}
    />
  );
};

export { CustomSelect, Box, CustomedTextField, SystemWrapper, UnitWrapper, TextInput, CustomAutoComplete };
